import React, {} from "react"
import {Slider} from '@mui/material'
import Cropper from 'react-easy-crop';
import '../../../css/InfluencerUpload.css'

export default function create_image_edit(image_shape, image) {
   if (image_shape == "circle") {
      var image_text = "round"
      var aspect = 1
      var submit_button = (
         <div>
            <button className="upload_icon_image_edit_file_button_close"  id="upload_icon_image_edit_file_button_close"
                    onClick={(e) => this.EditCropZoomIconImageOff(e)}>Confirm
            </button>
            <button className="upload_icon_image_edit_file_button_close_alt" id="upload_icon_image_edit_file_button_close_alt"
                    onClick={(e) => this.CloseCropZoomIconImageOff(e)}>Close
            </button>
         </div>
      )
   } else if (image_shape == "wide-screen") {
      var image_text = null;
      var aspect = 15 / 9;
      var submit_button = (
         <div>
            <button className="upload_icon_image_edit_file_button_close"  id="upload_icon_image_edit_file_button_close"
                    onClick={(e) => this.EditCropThumbnailImageOff(e)}>Confirm
            </button>
            <button className="upload_icon_image_edit_file_button_close_alt" id="upload_icon_image_edit_file_button_close_alt"
                    onClick={(e) => this.EditCropThumbnailImageOff(e)}>Close
            </button>
         </div>
      )
   } else if (image_shape == "wide-screen-image") {
      var image_text = null;
      var aspect = 15 / 9;
      var submit_button = (
         <div>
            <button className="upload_icon_image_edit_file_button_close"  id="upload_icon_image_edit_file_button_close"
                    onClick={(e) => this.EditCropThumbnailImageOff(e)}>Confirm
            </button>
            <button className="upload_icon_image_edit_file_button_close_alt" id="upload_icon_image_edit_file_button_close_alt"
                    onClick={(e) => this.EditCropThumbnailImageOff(e)}>Close
            </button>
         </div>
      )
   } else if (image_shape == "wide-screen-thumbnail-image") {
      var image_text = null;
      var aspect = 15 / 9;
      var submit_button = (
         <div>
            <button className="upload_icon_image_edit_file_button_close" id="upload_icon_image_edit_file_button_close"
                    onClick={(e) => this.EditCropThumbnailImageOff(e)}>Confirm
            </button>
            <button className="upload_icon_image_edit_file_button_close_alt" id="upload_icon_image_edit_file_button_close_alt"
                    onClick={(e) => this.EditCropThumbnailImageOff(e)}>Close
            </button>
         </div>
      )

   }
   return (
      <div className="crop_outer_div">
         <div className="crop-container" id="crop-container">
            <Cropper
               image={image}
               crop={this.state.crop}
               zoom={this.state.zoom}
               aspect={aspect}
               onCropChange={this.onCropChange}
               onCropComplete={this.onCropComplete}
               onZoomChange={this.onZoomChange}
               cropShape={image_text}
               showGrid={false}
            />
         </div>
         <div className="zoom_controls">
            <Slider
               style={{
                  width: '300px',
                  marginLeft: 'auto',
                  marginRight: 'auto',

               }}
               value={this.state.zoom}
               min={1}
               max={3}
               step={0.1}
               aria-labelledby="Zoom"
               onChange={(e, zoom) => this.onZoomChange(zoom)}
               classes={{container: 'zoom_slider'}}
            />
            <div className="zoom_slider_title"
                 style={{ width: '100%', marginLeft: 'auto', textAlign: 'center',
                    marginRight: 'auto', }}>
               Adjust Crop
            </div>
            {submit_button}
         </div>

      </div>
   )
}

